import { useMemo } from 'react';

import { UnstyledButton } from '../../../../Buttons/ButtonMantine';
import { Card, ImageMantine } from '../../../../DataDisplay';
import { AspectRatio, Stack } from '../../../../Layout';
import { Text } from '../../../../Typography';
import { CompletedIndicator } from '../../dataDisplay/indicators/CompletedIndicator';
import buy from './assets/buy.svg';
import earnDining from './assets/earnDining.svg';
import earnOnline from './assets/earnOnline.svg';
import give from './assets/give.svg';
import inStore from './assets/inStore.svg';

type HowToGivebackCardProps = {
  type: 'online' | 'dining' | 'in_store' | 'give' | 'purchases';
  onClick?: () => void;
  completed?: boolean;
};

const HowToGivebackCard = ({ type, onClick, completed }: HowToGivebackCardProps) => {
  const typeInfo = useMemo(() => {
    switch (type) {
      case 'online':
        return { src: earnOnline, label: 'Earn Online' };
      case 'dining':
        return { src: earnDining, label: 'Earn Dining' };
      case 'in_store':
        return { src: inStore, label: 'Earn in Store' };
      case 'give':
        return { src: give, label: 'Donate' };
      case 'purchases':
        return { src: buy, label: 'Purchases' };
    }
  }, [type]);
  return (
    <CompletedIndicator completed={completed}>
      <Stack
        w="100%"
        gap="xs"
        onClick={onClick}
        component={UnstyledButton}
        data-tracking-id={`how-to-give-back-${type}`}
      >
        <Card bg="cobalt.0" p="sm">
          <AspectRatio ratio={1 / 1}>
            <ImageMantine src={typeInfo.src} fit="contain" />
          </AspectRatio>
        </Card>
        <Text fw={500} fz="xs" ta="center">
          {typeInfo.label}
        </Text>
      </Stack>
    </CompletedIndicator>
  );
};

export { HowToGivebackCard };
